import "../App.css";
import React, { useState, useEffect } from "react";
import { call } from "../service/ApiService";
import {
  //Container,
  List,
  Paper,
  //Grid,
  // Button,
  // AppBar,
  // Toolbar,
  //Typography,
} from "@mui/material";

export function Admin() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/admin/userList", "POST", "").then((response) => {
      if (!response) {
        alert("누구냐 넌 : " + "접금.");
        window.location.href = "/home";
      }

      if (response.error) {
        alert("누구냐 넌 : " + response.error);
        window.location.href = "/home";
      }

      if (response.data) {
        setItems(response.data);
      }
    });
  }, []);

  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <div item={item} key={item.id}>
            {item.id}
            {" -- "}
            {item.username}
          </div>
        ))}
      </List>
    </Paper>
  );

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  let content = todoItems;

  /* 선택한 content 렌더링 */
  return <div className="loading">{content}</div>;
}

export default Admin;
